import axios from './axiosInstances/axiosInstance';

const URI = '/restaurants';

export const getRestaurantOperatingHours = (restaurantId, params) => {
  return axios.get(`${URI}/${restaurantId}/calendars`, { params });
};
